import {connect} from 'react-redux'
import {selectTour} from "../actions";
import Listing from '../components/Listing';

const mapStateToProps = state => ({
    tours:    state.tours.listing,
    selected: state.tours.registration.tour
});

const mapDispatchToProps = dispatch => ({
    select: (tour) => dispatch(selectTour(tour))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Listing)



// WEBPACK FOOTER //
// ./src/app/tours/containers/Listing.js